/*
 * Copyright © 2018-2025, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React, { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import { strings } from "../../common/Strings/Strings";
import DiscountSection from "./Discounts/DiscountSection";
import GlobalSettingsSection from "./GlobalSettingsSection";
import { PageProps } from "../../models/PageProps";
import { getAccessToken } from "../../util/LocalStorageVariables";
import SiteManagersSection from "./SiteManagersSection";
import { SiteManagerPage } from "./SiteManagerPage";
import { useChosenRole } from "../Main/Onboarding/ChooseRole";
import CountrySection from "./CountrySection";
import Tabs from "../../components/Tabs/Tabs";
import NotificationTemplatesSection from "./Notification/NotificationTemplatesSection";

function ManagerSettingsPage(props: PageProps) {
  const authorities: string[] = jwtDecode(getAccessToken())?.authorities || [];
  const { setPageLoading } = props;
  const [key, setKey] = useState<string>("config");

  useChosenRole("manager");
  useEffect(() => {
    setPageLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasAuthority = (authority: string): boolean =>
    authorities.includes("MANAGER_FULL") || authorities.includes(authority);

  const content = () => {
    switch (key) {
      case "config":
        if (hasAuthority("MANAGER_CONFIG")) {
          return (
            <div>
              <GlobalSettingsSection isActiveTab={key === "config"} />
            </div>
          );
        } else return <></>;
      case "countries":
        if (hasAuthority("MANAGER_CONFIG")) {
          return (
            <div>
              <CountrySection isActiveTab={key === "countries"} />
            </div>
          );
        } else {
          return <></>;
        }
      case "discounts":
        if (hasAuthority("MANAGER_FEES")) {
          return (
            <div>
              <DiscountSection isActiveTab={key === "discounts"} />
            </div>
          );
        } else return <></>;
      case "notifications":
        if (hasAuthority("MANAGER_CONFIG")) {
          return (
            <div>
              <NotificationTemplatesSection />
            </div>
          );
        } else return <></>;
      case "managers":
        if (hasAuthority("MANAGER_MANAGERS")) {
          return (
            <div>
              <SiteManagersSection isActiveTab={key === "managers"} />
            </div>
          );
        } else return <></>;
      default:
        return <></>;
    }
  };

  return (
    <div className="flex justify-center flex-col">
      <Tabs
        tabs={[
          {
            title: strings.config,
            tab: "config",
          },
          {
            title: strings.countries,
            tab: "countries",
          },
          {
            title: strings.discounts,
            tab: "discounts",
          },
          {
            title: strings.notifications,
            tab: "notifications",
          },
          {
            title: strings.managers,
            tab: "managers",
          },
        ]}
        currentTabKey={key}
        setTab={setKey}
      />
      <div>{content()}</div>
    </div>
  );
}

export default SiteManagerPage(ManagerSettingsPage, strings.SITE_MANAGER_SETTINGS);
